/** Shared sheet sizing for BaseModal drawers in the global menu (privacy, etc.). */

export interface MenuSheetLayout {
  outerMaxHeightPx: number;
  sheetMaxHeightPx: number;
}

const LAYOUT = {
  PANEL_MAX_WIDTH_PX: 540,
  WINDOW_WIDTH_FRACTION: 0.94,
  SHEET_MIN_HEIGHT_PX: 280,
  SHEET_MAX_HEIGHT_PX: 640,
  WINDOW_HEIGHT_SHEET_RATIO: 0.74,
  PANEL_HEIGHT_RATIO: 1.12,
  OUTER_EXTRA_BELOW_SHEET_PX: 72,
  WINDOW_HEIGHT_OUTER_RATIO: 0.96,
} as const;

export function computeMenuSheetLayout(
  windowWidth: number,
  windowHeight: number,
): MenuSheetLayout {
  const panelMaxWidth = Math.min(LAYOUT.PANEL_MAX_WIDTH_PX, windowWidth * LAYOUT.WINDOW_WIDTH_FRACTION);
  const sheetMaxHeightPx = Math.max(
    LAYOUT.SHEET_MIN_HEIGHT_PX,
    Math.min(
      Math.round(windowHeight * LAYOUT.WINDOW_HEIGHT_SHEET_RATIO),
      LAYOUT.SHEET_MAX_HEIGHT_PX,
      Math.round(panelMaxWidth * LAYOUT.PANEL_HEIGHT_RATIO),
    ),
  );
  const outerMaxHeightPx = Math.min(
    Math.round(windowHeight * LAYOUT.WINDOW_HEIGHT_OUTER_RATIO),
    sheetMaxHeightPx + LAYOUT.OUTER_EXTRA_BELOW_SHEET_PX,
  );
  return { sheetMaxHeightPx, outerMaxHeightPx };
}
